import React from "react";
import { Box } from "@mui/material";
import ManageOrdersIcon from "../../assets/homePage/manage-orders.svg";
import Ledgers from "../../assets/homePage/ledgers.svg";
import { useNavigate } from "react-router-dom";
import {
  ServiceCardContent,
  ServiceCardRoot,
  ServiceHeadingContainer,
  ServiceHeadingSubtitle,
  ServiceHeadingTitle,
  ServiceLink,
  ServiceSubtitle,
  ServiceTitle,
  TextContainer,
  TrackingBox,
} from "./TrackOrdersPayments.styles";
import colors from "../../theme/Colours";

interface ServiceCardProps {
  iconSrc: string;
  title: string;
  subtitle: string;
  linkText?: string;
  onLinkClick?: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  iconSrc,
  title,
  subtitle,
  linkText,
  onLinkClick,
}) => (
  <ServiceCardRoot>
    <ServiceCardContent>
      <Box
        component="img"
        src={iconSrc}
        alt={title}
        sx={{
          width: "50px",
          height: "50px",
          objectFit: "contain",
        }}
      />
      <TextContainer>
        <ServiceTitle variant="h6">{title}</ServiceTitle>
        <ServiceSubtitle variant="body2">{subtitle}</ServiceSubtitle>
      </TextContainer>
      <ServiceLink onClick={onLinkClick}>{linkText}</ServiceLink>
    </ServiceCardContent>
  </ServiceCardRoot>
);

const TrackOrdersPayments: React.FC = () => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId");
  const handleManageOrdersClick = () => navigate(`/maltora-customer/my-orders`);
  const handlePaymentsClick = () => navigate(`/maltora-customer/ledgers`);

  const cards = [
    {
      iconSrc: ManageOrdersIcon,
      title: "Manage Orders",
      subtitle: "Track order and status.",
      linkText: "View My Orders",
      onLinkClick: handleManageOrdersClick,
    },
    {
      iconSrc: Ledgers,
      title: "Ledger",
      subtitle:
        "Review outstanding invoices, and transaction history securely.",
      linkText: "View My Ledger",
      onLinkClick: handlePaymentsClick,
    },
  ];

  return (
    <>
      <TrackingBox>
        <ServiceHeadingContainer>
          <ServiceHeadingTitle>
            Track Your Orders and Payments
          </ServiceHeadingTitle>
          <ServiceHeadingSubtitle>
            Monitor order status, shipments, and payments easily
          </ServiceHeadingSubtitle>
        </ServiceHeadingContainer>
        <Box
          sx={{
            display: "flex",
            gap: 3,
            flexWrap: "wrap",
            justifyContent: "center",
            paddingTop: 4,
            paddingBottom: 6,
          }}
        >
          {cards.map((card, index) => (
            <ServiceCard key={index} {...card} />
          ))}
        </Box>
      </TrackingBox>
    </>
  );
};

export default TrackOrdersPayments;
